exports.components = {
  "component---src-pages-2023-js": () => import("./../../../src/pages/2023.js" /* webpackChunkName: "component---src-pages-2023-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-components-video-js": () => import("./../../../src/pages/components/Video.js" /* webpackChunkName: "component---src-pages-components-video-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

